import React from 'react';
import * as QRCode from 'qrcode';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';
import { SIZE } from '@motorway/mw-highway-code/enums';

import { VehicleLookupState } from 'Utilities/vehicles/@types';

import { Modal } from 'Storybook/components/local/Modal/Modal';
import { StepList } from 'Storybook/components/local/StepList';

import { HowVerificationWorksModal } from '../../../HowVerificationWorksModal/HowVerificationWorksModal';
import LocalTexts from '../../UploadDocuments.texts.json';

import { UploadVerificationSteps } from './UploadDocumentsVerification.helpers';

import styles from './UploadDocumentsVerification.scss';

const LocalT = new MDText(LocalTexts.uploadDocumentsVerification);

type UploadDocumentsVerificationWrapperProps = {
  children?: React.ReactNode;
  closeModal: () => void;
  isModalOpen: boolean;
  renderButton: ()=> React.ReactNode;
  showFSLStep?: boolean;
  slug: string;
  token?: string | null;
  vehicle: VehicleLookupState;
}

export const UploadDocumentsVerificationWrapper = ({
  children = null,
  closeModal,
  isModalOpen,
  renderButton,
  showFSLStep = false,
  slug,
  token,
  vehicle,
}: UploadDocumentsVerificationWrapperProps) => {
  const steps = UploadVerificationSteps({ showFSLStep });

  return <div>
    {isModalOpen && (
      <Modal
        contentClass={styles.confirmModal}
        dismissModal={closeModal}
        size={SIZE.SMALL}
      >
        <canvas
          ref={(node) => {
            const fullPath = `${globalThis.location.origin}/${vehicle.vrm}${slug}`;
            const url = new URL(fullPath);

            if (token) {
              url.searchParams.append('token', token);
            }

            url.searchParams.append('utm_medium', 'qr_code');

            const qrUrl = url.toString();

            if (node) {
              QRCode.toCanvas(node, qrUrl);
            }
          }}
        />
        <h2>{LocalT.translate('incodeQrModal.title')}</h2>
        <p>{LocalT.translate('incodeQrModal.content')}</p>

        <Button fullWidth label={LocalT.translate('incodeQrModal.confirm')} onClick={closeModal} />
      </Modal>
    )}
    <div className={styles.uploadDocumentsVerification}>
      <div className={styles.summary}>
        <h2 className={styles.title}>{LocalT.translate('documentVerification')}</h2>
        <p data-thc-style-override className={styles.info}>{LocalT.translate('documentVerificationDescription')}</p>
        <HowVerificationWorksModal/>
      </div>
      <div className={styles.steps}>
        <h5 className={styles.stepsTitle}>{LocalT.translate('steps.justXSteps', { count: steps.length })}</h5>
        <StepList align='center' counter='hidden' {...{ steps }}/>
      </div>
      <div className={styles.buttonContainer}>
        {renderButton()}
        {children}
      </div>
    </div>
  </div>;
};
